import React, { useEffect } from 'react';
import { connect } from 'redux-bundler-react';
import StepHeader from '@src/app-components/step-header/StepHeader.jsx';
import ExternalLink from '@components/external-link/ExternalLink';
import { Alert } from '@trussworks/react-uswds';
import LinkButton from '@components/link/linkButton';
import { FileTypes, ResourceFiles } from '@src/utils/enums';
import { useRequest } from '@stores';

export const ViolationsFormInstructionsMetadata = {
  header: 'Report Potential Violation',
  sectionName: 'Instructions',
};

const ViolationsFormInstructions = connect('doDownloadFile', ({ doDownloadFile, stepNo }) => {
  const updateSection = useRequest((state) => state.updateSection);

  useEffect(() => {
    updateSection(stepNo, { valid: true, label: ViolationsFormInstructionsMetadata.sectionName });
  }, [updateSection, stepNo]);

  return (
    <>
      <StepHeader text='Instructions' />
      <p>
        The <span className='text-bold'>report of Unauthorized Activity or Non-compliance request</span> provides the
        public with an electronic means to report a potential unauthorized activity or permit noncompliance to the U.S.
        Army Corps of Engineers (USACE).
      </p>
      <p>
        Enforcement, as part of the overall regulatory program of the USACE, is based on a policy of regulating the
        waters of the United States by discouraging activities that have not been properly authorized and by requiring
        corrective measures, where appropriate, to ensure those waters are not misused and to maintain the integrity of
        the Regulatory Program.
      </p>

      <div className='text-bold margin-bottom-2'>There are two general categories of USACE enforcement:</div>

      <p className='margin-left-1'>
        <span className='text-bold'>Unauthorized Activities: </span> These are activities that require USACE
        authorization but have been performed without required USACE permits.
      </p>

      <p className='margin-left-1'>
        <span className='text-bold'>Permit Non-Compliance: </span> These involve circumstances where a permittee has
        violated the terms or conditions of an issued permit and where the violation is sufficiently serious to require
        an enforcement action.
      </p>

      <p>
        Please complete all forms fields in the subsequent sections of this form and provide any information that you
        believe would assist with our investigation. Information such as maps, photographs, alleged violator contact
        information, if known, and dates/times that the alleged activities occurred may be particularly useful to
        support our investigation. While it is strongly recommended to make the report electronically, you can also make
        this report to the local USACE district office by traditional mail or email. To locate your local USACE
        Regulatory office, please visit: <ExternalLink href='https://regulatory.ops.usace.army.mil/offices/' />
      </p>
      <p>
        <span className='text-bold'>
          If you started this request and initially chose "No" when asked "Do you wish to remain anonymous?", but now
          prefer to select “Yes” to remain anonymous, you may exit this form and start the request again. Then select
          “Yes” to the anonymous question.
        </span>
      </p>
      <Alert className='margin-bottom-2' type='warning' heading='NOTICE:' headingLevel='h5' noIcon>
        You will not receive update notifications on an anonymous submissions.
      </Alert>
      <p>
        Thank you for providing the information in this report. The information provided in the report may be used to
        initiate an investigation and enforcement proceeding.{' '}
        <span className='text-bold'>
          However, enforcement is a discretionary duty of the USACE and deviation from the procedures in the USACE
          enforcement regulations (33 CFR 326) shall not give rise to a private right of action against a USACE
          District. Additionally, unless you are party to the enforcement, it is unlikely that the USACE District will
          provide you with regular updates regarding the status of any enforcement action.
        </span>
      </p>
      <div className='margin-top-2'>
        <LinkButton
          onClick={() => doDownloadFile(ResourceFiles.Reg101FreqUsedTerms, FileTypes.Resource)}
          title='RRS Commonly Used Regulatory Terms [PDF, 9 pages]'
          content='RRS Commonly Used Regulatory Terms [PDF, 9 pages]'
        />
      </div>
    </>
  );
});

ViolationsFormInstructions.metadata = ViolationsFormInstructionsMetadata;

export default ViolationsFormInstructions;
